export default "__VITE_ASSET__DCRK9fFe__"